import { AngularFirestore } from '@angular/fire/firestore';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs/internal/Observable';
import { AngularFireDatabase } from '@angular/fire/database';
import { Plugins, Storage } from '@capacitor/core';

@Injectable({
  providedIn: 'root',
})
export class DbService {
  constructor(
    private afs: AngularFirestore,
    private ard: AngularFireDatabase
  ) {}

  /**
   *
   *
   *  @param {string} path 'collection' or 'collection/docID'
   * @param {object} data new data
   * Creates or update data on collection or document
   */

  collection$(path: string, query?) {
    return this.afs
      .collection(path, query)
      .snapshotChanges()
      .pipe(
        map((actions) => {
          return actions.map((a) => {
            const data: Object = a.payload.doc.data();
            const id = a.payload.doc.id;
            return { id, ...data };
          });
        })
      );
  }

  doc$(path): Observable<any> {
    return this.afs
      .doc(path)
      .snapshotChanges()
      .pipe(
        map((doc: any) => {
          return { id: doc.payload.key, ...doc.payload.data() };
        })
      );
  }

  getDoc(path) {
    return this.afs.doc(path).get().toPromise();
  }

  updateAt(path: string, data: Object): Promise<any> {
    const segments = path.split('/').filter((v) => v);

    if (segments.length % 2) {
      return this.afs.collection(path).add(data);
    } else {
      return this.afs.doc(path).set(data, { merge: true });
    }
  }

  /**
   *
   *
   * @param {string} path 'delete
   *
   * Delete data on document level
   */
  delete(path: string) {
    return this.afs.doc(path).delete();
  }

  //Realtime

  getRDB(path) {
    const items = this.ard
      .list(path)
      .snapshotChanges()
      .pipe(
        map((arr) => {
          return arr.map((snap: any) => {
            const payload = {
              key: snap.key,
              value: snap.payload.val(),
            };

            return payload;
          });
        })
      );
    return items;
  }

  getRRBDoc(path) {
    return this.ard.object(path).valueChanges();
  }

  updateAtRDB(path, payload) {
    return this.ard.database.ref(path).set(payload);
  }

  deleteRDB(path) {
    return this.ard.database.ref(path).remove();
  }

  async setItem(key, value) {
    return await Storage.set({
      key,
      value,
    });
  }

  async getItem(key) {
    return await Storage.get({ key });
  }

  async removeItem(key) {
    return await Storage.remove(key);
  }

  filterItems(list: any[], key, searchTerm: string) {
    console.log(list);
    return list.filter((item: any) => {
      return item[key].toLowerCase().indexOf(searchTerm.toLowerCase()) > -1;
    });
  }
}
